module.exports = __webpack_public_path__ + "static/media/S4P2_treatment-implications.040225e4.mp3";